import gsap from 'gsap';
import {animationManager} from './animationManager';

const mastheadTimelineId = 'masthead-animation';
const mastheadClassName = '.wp-block-section-masthead';

const mastheadH1ClassName = mastheadClassName + ' h1';
const mastheadPClassName = mastheadClassName + ' p';

const createMastheadAnimation = (timeline: gsap.core.Timeline): void => {
    gsap.set(mastheadH1ClassName, { opacity: 0, y: 20 });
    gsap.set(mastheadPClassName, { opacity: 0, y: 20 });

    timeline.fromTo(mastheadH1ClassName,
        {opacity: 0, y: 200},
        {opacity: 1, y: 0, duration: 0.5, ease: 'power2.out', clearProps: "all"}
    );
    timeline.fromTo(mastheadPClassName,
        {opacity: 0, y: 200},
        {
            opacity: 1,
            y: 0,
            delay: 0.8,
            duration: 0.8,
            ease: 'power2.out',
            clearProps: "all"
        },
        '-=1.2'
    );
};

animationManager.registerAnimation({
    timelineId: mastheadTimelineId,
    createAnimation: createMastheadAnimation,
    scrollTrigger: {
        trigger: mastheadClassName, // Add the trigger here
        config: {
            start: 'top bottom', // Adjust start and end as needed
            end: 'bottom top',
            // markers: true, // For debugging
        },
    },
});
